<template>
    <div class="w-full h-full">
        <div v-text="value"  v-if="!isEdit" :class="classes"  @dblclick="toggle"></div>
        <input type="text"
               v-if="isEdit"
               v-model="value"
               @change="onChange"
               @keyup.enter="onBlur(false)"
               :class="classes"
               autofocus
        >
    </div>
</template>

<script>
    import EditCell from '../mixins/EditCell';

    export default {

        mixins: [EditCell],

    }
</script>
